{
  "title": "Comparatif des hangars",
  "buttons": {
    "stack": "Pile"
  },
  "resultGrid": {
    "columns": {
      "hangar": "Hangar",
      "progress": "Progression",
      "variants": "# Variantes",
      "placed": "# Placé",
      "duration": "Durée",
      "utilization": "Utilisation",
      "topUtilizations": "Top 4 utilisations",
      "viewResults": "Voir les résultats"
    }
  }
}
